import { render, staticRenderFns } from "./IconIntegralRule.vue?vue&type=template&id=70b9ba66&scoped=true&"
import script from "./IconIntegralRule.vue?vue&type=script&lang=js&"
export * from "./IconIntegralRule.vue?vue&type=script&lang=js&"
import style0 from "./IconIntegralRule.vue?vue&type=style&index=0&id=70b9ba66&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b9ba66",
  null
  
)

export default component.exports